import { createFileRoute } from '@tanstack/react-router';
import RouteAssignment from '~/containers/RouteAssignment';

export const Route = createFileRoute('/weekplan/assignment/$shiftId/$turnId')({
  component: RouteAssignment,
  validateSearch(search: Record<string, unknown>) {
    return {
      from: (search.from as string) || undefined,
    };
  },
});
